const initSiv014 = () => {
	const sivaraUrls = ["https://sivara.de/products/sivara-komfort-bh-naht-und-bugellos-test", "https://sivara.de/products/sivara-komfort-bh-naht-und-bugellos-test2", "https://sivara.de/products/sivara-komfort-bh-naht-und-bugellos-koop", "https://sivara.de/products/sivara-komfort-bh-naht-und-buegellos", "https://sivara.de/products/sivara-komfort-bh-plus"];

	if (sivaraUrls.some((url) => window.location.href.includes(url))) {
		const sizeKickElement = document.querySelector("#sizekickWidget").parentNode.parentNode;
		if (!sizeKickElement) return;

		const sizeChartButton = document.querySelector("[data-js-siv-014-size-chart-button]");
		if (!sizeChartButton) return;

		const originalSizeChartButton = document.querySelector("[data-js-siv-014-original-size-chart-button]");
		if (!originalSizeChartButton) return;

		let sizeKickButton;

		const tryInjectStyles = () => {
			const widgetApp = sizeKickElement.querySelector("szk-widget-app");

			if (widgetApp?.shadowRoot) {
				window.requestAnimationFrame(() => {
					const findSizeElement = widgetApp.shadowRoot.querySelector("szk-widget-find-size");

					if (findSizeElement) {
						if (findSizeElement.shadowRoot) {
							const findSizeButton = findSizeElement?.shadowRoot.querySelector("button.find-my-size");
							sizeKickButton = findSizeButton;
							sizeChartButton.addEventListener("click", handleSizechartButtonClick);
							sizeChartButton.classList.remove("hidden");
							return true;
						}
					} else {
						const recommendationElement = widgetApp.shadowRoot.querySelector("szk-widget-recommendation");
						if (recommendationElement) {
							setTimeout(() => {
								if (recommendationElement.shadowRoot) {
									// The app takes a while to load the record, so we need to wait for it to be loaded
									setTimeout(() => {
										const recommendationButton = recommendationElement.shadowRoot.querySelector("button#detailed-reco");
										sizeKickButton = recommendationButton;
										sizeChartButton.addEventListener("click", handleSizechartButtonClick);
										sizeChartButton.classList.remove("hidden");
										return true;
									}, 800);
								}
							}, 400);
						}
					}
				});
			}
			return false;
		};

		const handleSizechartButtonClick = () => {
			window["ablyft"] = window["ablyft"] || [];
			window["ablyft"].push({
				eventType: "activatePage",
				pageApiName: "siv-014",
			});

			const variant = localStorage.getItem("siv-014");

			if (variant) {
				if (variant === "a") {
					originalSizeChartButton.click();
				}

				if (variant === "b") {
					sizeKickButton.click();
				}
			} else {
				originalSizeChartButton.click();
			}
		};

		const observer = new MutationObserver(() => {
			if (tryInjectStyles()) {
				observer.disconnect();
			}
		});
		observer.observe(sizeKickElement, { childList: true, subtree: true });
	} else {
		const sizeChartButton = document.querySelector("[data-js-siv-014-size-chart-button]");
		if (!sizeChartButton) return;

		const originalSizeChartButton = document.querySelector("[data-js-siv-014-original-size-chart-button]");
		if (!originalSizeChartButton) return;

		sizeChartButton.addEventListener("click", () => {
			originalSizeChartButton.click();
		});
		sizeChartButton.classList.remove("hidden");
	}
};

document.addEventListener("DOMContentLoaded", initSiv014);
